import { IEditEngagementRequestPayload, IEditEngagementSuccessPayload } from '../../types/bucket';
import { IApiError } from '../../types/shell';

export const EDIT_ENGAGEMENT_REQUEST = 'EDIT_ENGAGEMENT_REQUEST';
export const EDIT_ENGAGEMENT_SUCCESS = 'EDIT_ENGAGEMENT_SUCCESS';
export const EDIT_ENGAGEMENT_FAILURE = 'EDIT_ENGAGEMENT_FAILURE';
export const EDIT_ENGAGEMENT_CANCELLED = 'EDIT_ENGAGEMENT_CANCELLED';

export const EDIT_ENGAGEMENT_CANCELLATION = Object.freeze({ cancelled: true });

export const isEditEngagementCancellation = (reason: unknown): boolean => reason === EDIT_ENGAGEMENT_CANCELLATION;

export const editEngagementRequest = (payload: IEditEngagementRequestPayload) => ({
  type: EDIT_ENGAGEMENT_REQUEST,
  payload,
});

export const editEngagementSuccess = (payload: IEditEngagementSuccessPayload) => ({
  type: EDIT_ENGAGEMENT_SUCCESS,
  payload,
});

export const editEngagementFailure = (payload?: IApiError) => ({
  type: EDIT_ENGAGEMENT_FAILURE,
  payload,
});

export const editEngagementCancelled = () => ({
  type: EDIT_ENGAGEMENT_CANCELLED,
});
